import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import AuthModal from "../components/AuthModal";
import Footer from "../components/Footer";
import "./CategoryPage.css";

const BASE = "https://storage.googleapis.com/rasai-nutrie-assets/products/food";

const foodProducts = [
  { id: "food-pumpkin-sambar", name: "Pumpkin Sambar", price30: 57,  price60: 98,  image: `${BASE}/pumpkin-sambar.png` },
  { id: "food-quinoa-sambar",  name: "Quinoa Sambar",  price30: 43,  price60: 140, image: `${BASE}/quinoa-sambar.png` },
  { id: "food-moringa-mix",    name: "Moringa Mix",    price30: 48,  price60: 109, image: `${BASE}/moringa-mix.png` },
  { id: "food-jujube-mix",     name: "Jujube Mix",     price30: 50,  price60: 82,  image: `${BASE}/jujube-mix.png` },
  { id: "food-amla-rasam",     name: "Amla Rasam",     price30: 53,  price60: 89,  image: `${BASE}/amla-rasam.png` },
  { id: "food-dates-rasam",    name: "Dates Rasam",    price30: 63,  price60: 109, image: `${BASE}/dates-rasam.png` },
  { id: "food-beetroot-pulao", name: "Beetroot Pulao", price30: 70,  price60: 130, image: `${BASE}/beetroot-pulao.png` },
  { id: "food-green-pulao",    name: "Green Pulao",    price30: 91,  price60: 159, image: `${BASE}/green-pulao.png` },
];

const FoodCard = ({ product }) => {
  const { isAuthenticated } = useAuth();
  const { cartItems, addToCart, updateQuantity, removeFromCart } = useCart();
  const [size, setSize] = useState("30g");
  const [showAuthModal, setShowAuthModal] = useState(false);

  const cartId = `${product.id}-${size}`;
  const price = size === "30g" ? product.price30 : product.price60;
  const cartItem = cartItems.find((item) => item.id === cartId);
  const quantity = cartItem ? cartItem.quantity : 0;

  const handleAdd = () => {
    if (!isAuthenticated) { setShowAuthModal(true); return; }
    addToCart({ id: cartId, name: `${product.name} (${size})`, price, image: product.image });
  };

  return (
    <>
      {showAuthModal && <AuthModal onClose={() => setShowAuthModal(false)} />}
      <div className="product-card">
        <div className="product-card-image-wrap">
          <img src={product.image} alt={product.name} className="product-card-image" />
        </div>
        <div className="product-card-info">
          <h3 className="product-card-name">{product.name}</h3>
          <div className="product-size-toggle">
            <button className={`size-btn ${size === "30g" ? "size-btn--active" : ""}`} onClick={() => setSize("30g")}>30g</button>
            <button className={`size-btn ${size === "60g" ? "size-btn--active" : ""}`} onClick={() => setSize("60g")}>60g</button>
          </div>
          <p className="product-card-price">₹{price}</p>
          {quantity === 0 ? (
            <button className="product-card-btn" onClick={handleAdd}>Add to Cart</button>
          ) : (
            <div className="qty-control">
              <button className="qty-btn" onClick={() => quantity === 1 ? removeFromCart(cartId) : updateQuantity(cartId, quantity - 1)}>−</button>
              <span className="qty-value">{quantity}</span>
              <button className="qty-btn" onClick={() => updateQuantity(cartId, quantity + 1)}>+</button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const FoodProductsPage = () => (
  <div className="category-page">
    <div className="category-hero" style={{ backgroundImage: `url(${BASE}/banner.png)` }}>
      <div className="category-hero-overlay">
        <Link to="/products" className="category-back">← All Categories</Link>
        <h1 className="category-hero-title">FOOD PRODUCTS</h1>
        <p className="category-hero-sub">Traditional recipes · Modern nutrition · RASAI nutrie</p>
      </div>
    </div>
    <div className="category-body" style={{ backgroundImage: `url(${BASE}/background.png)` }}>
      <div className="category-grid category-grid--4">
        {foodProducts.map((product) => (
          <FoodCard key={product.id} product={product} />
        ))}
      </div>
    </div>
    <Footer />
  </div>
);

export default FoodProductsPage;
